import React from "react";
import { CREDITS } from "@/constants/site";
import SITE_IDS from "@/constants/testIds/site";
import { ArrowUpRight } from "lucide-react";

// The Credits — a sincere, understated thank-you to every vendor.
// Reads like the credits page of a printed program: role label, serif
// name (linked), one line of appreciation, hairline rules between rows.
export default function CreditsSection() {
  return (
    <section id="credits" data-testid={SITE_IDS.creditsSection} className="section credits">
      <div className="container">
        <div className="credits__head">
          <span className="eyebrow">With Thanks</span>
          <h2 className="section__title font-display">The Credits</h2>
          <p className="section__lede">
            A wedding is a group project. These are the people who took our
            ideas seriously, made them better, and made March 14th a day
            we&rsquo;ll always celebrate. If you&rsquo;re planning a day of
            your own, hire every single one of them.
          </p>
        </div>

        <ul className="credits__list">
          {CREDITS.map((credit) => (
            <li className="credit-row" key={credit.name}>
              <span className="credit-row__role">{credit.role}</span>
              <div className="credit-row__body">
                <a
                  className="credit-row__name font-display"
                  href={credit.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {credit.name}
                  <ArrowUpRight size={16} strokeWidth={1.5} aria-hidden="true" />
                </a>
                <p className="credit-row__line">{credit.line}</p>
              </div>
            </li>
          ))}
        </ul>

        <p className="credits__close">
          Thank you for taking such good care of us.
          <span className="credits__close-sign"> — Kara &amp; Kevin</span>
        </p>
      </div>
    </section>
  );
}
